import { ASSETS_FOLDER, ENGINE_PATH_PREFIX, PROJECT_PATH_PREFIX } from '@gnsx/genesys.js';

import { JS_CLASSES_DIR_NAME, SHOW_JS_CLASSES_IN_ASSET_BROWSER } from '@/const';

const EXCLUDED_ASSET_PATHS = [
  `${ENGINE_PATH_PREFIX}/assets/dev`,
  /** SDK-managed compile cache; not user-facing project content. */
  `${PROJECT_PATH_PREFIX}/.genesys/cache`,
] as const;

const normaliseAssetPath = (path: string): string => path.replaceAll('\\', '/');

const isPathWithinExcludedSubtree = (path: string, excludedPath: string): boolean => {
  const normalisedPath = normaliseAssetPath(path);
  return normalisedPath === excludedPath || normalisedPath.startsWith(`${excludedPath}/`);
};

export const isExcludedAssetPath = (path: string): boolean => {
  const normalisedPath = normaliseAssetPath(path);

  if (EXCLUDED_ASSET_PATHS.some(excludedPath => isPathWithinExcludedSubtree(normalisedPath, excludedPath))) {
    return true;
  }

  // @engine maps to the editor public/ folder which contains internal directories
  // (engine-thumbnails, CHANGELOG.md etc.) that are not user-facing game assets.
  // Thumbnails remain available at static /engine-thumbnails/... URLs via manifest.
  // Only @engine/assets (and optionally the virtual @js-classes folder) are user-facing.
  if (
    normalisedPath === `${PROJECT_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}` ||
    normalisedPath.startsWith(`${PROJECT_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}/`) ||
    normalisedPath === `${ENGINE_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}` ||
    normalisedPath.startsWith(`${ENGINE_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}/`)
  ) {
    return !SHOW_JS_CLASSES_IN_ASSET_BROWSER;
  }

  if (normalisedPath.startsWith(`${ENGINE_PATH_PREFIX}/`)) {
    const allowed =
      normalisedPath.startsWith(`${ENGINE_PATH_PREFIX}/${ASSETS_FOLDER}`) ||
      (SHOW_JS_CLASSES_IN_ASSET_BROWSER && (
        normalisedPath === `${ENGINE_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}` ||
        normalisedPath.startsWith(`${ENGINE_PATH_PREFIX}/${JS_CLASSES_DIR_NAME}/`)
      ));
    return !allowed;
  }

  return false;
};
